import moment from 'moment'

export const WebUrl = 'https://1stopwash.com'
// export const ApiUrl = "http://localhost:1998"
export const ApiUrl = 'https://api.1stopwash.com'
// import Request from './Request'

export const geoJsonKey = 'MY49-RW74-JH79-CX92' //loqate key

export const poundIcon = '£'

export const chooseLocationFields = ['Company', 'SubBuilding', 'Line1', 'BuildingNumber', 'Street']

let dateFormatValue = 'DD-MMM-YYYY'
export const dateFormat = dateFormatValue

export const dateMoment = (date) => {
    let newDate = ''
    if (date) {
        newDate = moment(date).format(dateFormatValue)
    }
    return newDate
}

export const dateString = (date) => {
    let newDate = ''
    if (date) {
        newDate = moment.unix(date).format(dateFormatValue)
    }
    return newDate
}

export const logoutFxn = async () => {
    // await Request.logout()
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('globalPermission')
    window.location.reload()
}
